const PrivacyPolicy = () => {
    return ( 
        <div className="container mx-auto mt-8 p-6  rounded-lg shadow-xl mb-10">
    <h1 className="text-5xl font-extrabold mb-10 text-center underline ">Privacy Policy</h1>

    <p className="text-center mb-8 text-lg font-medium">Last Updated: 21 Dec 2023</p>

    <section className="pt-8">
        <h2 className="text-3xl font-semibold mb-6">Welcome to Wallcrafty!</h2>
        <p>
          This Privacy Policy describes how Wallcrafty ("we," "us," or "our")
          collects, uses, and discloses your information when you use our mobile
          application ("App"). By downloading and using the App, you agree to
          the terms outlined in this Privacy Policy.
        </p>
      </section>

      <section className="pt-8">
        <h2 className="text-3xl font-semibold mb-6">1. Information We Collect</h2>

        <p>
          <strong>1.1 Information You Provide:</strong> We may collect
          information that you voluntarily provide when using the App, such as
          when you create an account, contact us for support, or interact with
          our content.
        </p>

        <p>
          <strong>1.2 Automatically Collected Information:</strong> We may
          automatically collect certain information when you use the App,
          including your device information, and usage data. This information
          helps us improve the functionality and performance of the App.
        </p>
      </section>

      <section className="pt-8">
        <h2 className="text-3xl font-semibold mb-6">
          2. How We Use Your Information
        </h2>

        <p>
          <strong>2.1 Providing and Improving the App:</strong> We use your
          information to operate, maintain, and enhance the features of the App.
          This includes analyzing usage patterns, troubleshooting issues, and
          improving user experience.
        </p>

        <p>
          <strong>2.2 Communications:</strong> We may use your contact
          information to send you important updates and notifications related to
          the App, such as changes to our terms or privacy policy.
        </p>
      </section>

      <section className="pt-8">
        <h2 className="text-3xl font-semibold mb-6">3. Information Sharing</h2>

        <p>
          We do not sell, trade, or otherwise transfer your information to third
          parties. However, we may share your information in the following
          situations:
        </p>

        <p>
          <strong>3.1 Service Providers:</strong> We may share your information
          with third-party service providers that assist us in delivering and
          improving the App.
        </p>

        <p>
          <strong>3.2 Legal Compliance:</strong> We may disclose your
          information if required by law or in response to a valid legal
          request.
        </p>
      </section>

      <section className="pt-8">
        <h2 className="text-3xl font-semibold mb-6">4. Security</h2>

        <p>
          We take reasonable measures to protect the information we collect from
          unauthorized access or disclosure. However, no method of transmission
          over the internet or electronic storage is entirely secure, and we
          cannot guarantee absolute security.
        </p>
      </section>

      <section className="pt-8">
        <h2 className="text-3xl font-semibold mb-6">5. Children's Privacy</h2>

        <p>
          The App is not intended for children under the age of 13. We do not
          knowingly collect or solicit personal information from children. If
          you are a parent or guardian and believe that your child has provided
          us with personal information, please contact us, and we will take
          steps to remove that information.
        </p>
      </section>

      <section className="pt-8">
        <h2 className="text-3xl font-semibold mb-6">
          6. Changes to This Privacy Policy
        </h2>

        <p>
          We may update this Privacy Policy from time to time, and the most
          current version will be posted on this page. We encourage you to
          review this Privacy Policy periodically.
        </p>
      </section>

    {/* ... other sections follow the same pattern ... */}

    <section className="pt-8">
        <h2 className="text-3xl font-semibold mb-6">7. Contact Us</h2>
        <p className="text-lg">
            If you have any questions, concerns, or requests regarding this
            Privacy Policy, please contact us at{" "}
            <a href="mailto:wallcraftyapp1@gmail.com" className="underline text-blue-500 hover:text-blue-700 transition duration-300">
                wallcraftyapp1@gmail.com
            </a>.
        </p>
    </section>
</div>
     );
}
 
export default PrivacyPolicy;